import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Select from "react-select";
import {getPayoutAffiliateList} from "../../../../store/reducers/accountSlice";
import {paymentMethods, payoutRequest} from "../../../../utils/apis/payment";
import "./style.scss";

import Spinner from "../../../../reusableComponents/Spinner";
import {returnErrors} from "../../../../store/reducers/error";
import {returnMessages} from "../../../../store/reducers/message";
import customStyles, {newCryptoSelectorStyles, newSelectorStyles} from "../../../../customstyle/customstyle";
import RecipientBankDetails from "../../RecipientBankDetails";
import edit from "../../../../assets/icons/edit-pencil copy.svg";
import InvoiceDetails from "../../../FundingEvaluation/PaymentModule/InvoiceDetails";
import {formatUSD} from "../../../../utils/helpers/string";
import {Modal} from "antd";

function AffiliatePayout({isReqPayout, setReqPayout}) {
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();
  const payoutAfs = useSelector((state) => state.account.payoutListAFS);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  useEffect(() => {
    dispatch(getPayoutAffiliateList(idToken));
  }, [idToken]);
  const [totalAmount, setTotalAmount] = useState(payoutAfs?.data);
  useEffect(() => {
    setTotalAmount(payoutAfs?.data);
  }, [payoutAfs]);

  const [restrictAllPayout, setRestrictAllPayout] = useState(false);
  const [isRestrictModalVisible, setIsRestrictModalVisible] = useState(false);

  const methodOptions = [
    {
      label: (
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px"}}>
          <span>WIRE</span>{" "}
          <img
            src={edit}
            alt=""
            style={{marginRight: "15px"}}
            onClick={(e) => {
              e.stopPropagation();
              setValue(3);
            }}
          />
        </div>
      ),
      value: "SWIFT",
    },

    {
      label: (
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px"}}>
          <span>USDT BEP-20 (Binance Smart Chain)</span>{" "}
          <img
            src={edit}
            alt=""
            style={{marginRight: "15px"}}
            onClick={(e) => {
              e.stopPropagation();
              setValue(7);
            }}
          />
        </div>
      ),
      value: "USDT BEP-20",
    },

    {
      label: (
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px"}}>
          <span>USDT ERC-20 (Ethereum)</span>{" "}
          <img
            src={edit}
            alt=""
            style={{marginRight: "15px"}}
            onClick={(e) => {
              e.stopPropagation();
              setValue(6);
            }}
          />
        </div>
      ),
      value: "USDT ERC-20",
    },
  ];

  const totalAmounts = totalAmount.reduce((acc, item) => acc + item.amount, 0);
  const commission = totalAmount.map((item) => item.id);

  const [payout, setPayout] = useState({
    amount_requested: totalAmounts,
    reason: "",
    login_id: null,
    payout_type: "AFS",
    method: "",
    commission: [],
  });

  useEffect(() => {
    setPayout({...payout, commission: commission, amount_requested: totalAmounts});
  }, [totalAmount]);

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    if (e.target.type === "number") {
      setPayout({...payout, [name]: Number(value)});
    } else {
      setPayout({...payout, [name]: value});
    }
  };

  const handleSelectMethod = (selectedOption) => {
    if (selectedOption.value === "USDT BEP-20") {
      setPayout({...payout, method: "CRYPTO", crypto_type: "USDT BEP-20"});
      setValue(7);
    } else if (selectedOption.value === "USDT ERC-20") {
      setPayout({...payout, method: "CRYPTO", crypto_type: "USDT ERC-20"});
      setValue(6);
    } else {
      setPayout({...payout, method: selectedOption.value});
    }
  };

  const formData = payout; //new FormData();
  // for (const key in payout) {
  //   formData.append(key, payout[key]);
  // }

  const [isSpinner, setIsSpinner] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [refreshBanksDetails, setRefreshBanksDetails] = useState(false);

  const [paymentDetails, setPaymentdetails] = useState([]);
  const fetchPaymentdetails = async () => {
    const respo = await paymentMethods(idToken, dispatch);
    setPaymentdetails(respo);
  };
  useEffect(() => {
    fetchPaymentdetails();
  }, [refreshBanksDetails]);
  const closeBankDetailsModal = (e) => {
    setValue(false);
    if(e===true){
    setPayout((pre) => ({...pre, method: "",crypto_type:""}));

    }
    
  };
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (payout?.method === "SWIFT") {
      setValue(3);
    } else if (payout?.method === "CRYPTO" && payout?.crypto_type === "USDT BEP-20") {
      setValue(7); // BEP modal
    } else if (payout?.method === "CRYPTO") {
      setValue(6); // ERC modal
    }
  }, [payout?.method, payout?.crypto_type]);

  const handleSubmit = async () => {
    // // Prevent double-submit
    // if (restrictAllPayout && selectedBrand?.brand === "equity_edge") {
    //   setIsRestrictModalVisible(true);
    //   return;
    // }

    // // Now lock further requests
    // setRestrictAllPayout(true);

    // Validate inputs
    if (!payout.commission || payout.commission.length === 0) {
      dispatch(returnErrors("Please enter a valid amount", 400));
      return;
    }

    if (!payout.method) {
      dispatch(returnErrors("Please select a payout method", 400));
      return;
    }

    setIsSpinner(true);

    try {
      const response = await payoutRequest(idToken, formData);

      if (response.status === 200 || response.status === 201) {
        dispatch(returnMessages("Payout successful", 200));
        // Reset form inputs after successful submit
        setPayout({
          amount_requested: totalAmounts,
          reason: "",
          login_id: null,
          payout_type: "AFS",
          method: "",
          commission: commission,
        });
        setValue(null);
      } else {
        // Handle known error responses
        const errorData = response?.response?.data;
        let errorMessage = "Payout failed. Please try again.";

        if (errorData) {
          if (errorData.amount) {
            errorMessage = errorData.amount[0];
          } else if (errorData.detail) {
            errorMessage = errorData.detail;
          } else if (errorData.message) {
            errorMessage = errorData.message;
          }
        }

        dispatch(returnErrors(errorMessage, response.status || 400));
      }
    } catch (error) {
      // Handle network or unexpected errors
      const errorMessage =
        error.message === "Network Error" ? "Network error. Please check your connection." : error.response?.data?.detail || error.response?.data?.message || "An unexpected error occurred";

      dispatch(returnErrors(errorMessage, error.response?.status || 500));
    } finally {
      setIsSpinner(false);
    }
  };

  const [selectedAddress, setSelectedAddress] = useState(0);

  console.log("methodOptions", methodOptions, payout?.crypto_type);

  return (
    <div className="reqpayout">
      <RecipientBankDetails
        refreshBanksDetails={refreshBanksDetails}
        setRefreshBanksDetails={setRefreshBanksDetails}
        value={value}
        setValue={setValue}
        closeBankDetailsModal={closeBankDetailsModal}
      />
      {/* <Modal
        title="Action Blocked"
        visible={isRestrictModalVisible}
        onOk={() => setIsRestrictModalVisible(false)}
        onCancel={() => setIsRestrictModalVisible(false)}
        okText="OK"
        cancelButtonProps={{style: {display: "none"}}}
        className="payoutRestrictModal"
      >
        <p className="payoutModalText">Payout requests are temporarily disabled from 24 to 31 July due to a critical system upgrade ahead of our MT5 launch.</p>
        <br />
        <p className="payoutModalText">
          If you were eligible for a payout during this period, you’ll receive a free MT5 2-Step EE $5K Challenge with your next payout request by opening a support ticket.
        </p>
      </Modal> */}
      <div className="affiliate_payout_wrapper">
        <div className="col1">
          <div className="withdrawal_amount">
            <p>
              Total Withdrawal Amount*:- <span style={{fontWight: "500"}}> {formatUSD(totalAmounts || 0)} </span>
              <span></span>
            </p>
          </div>
          <div className="col1_lower">
            <div className="col1_lower_select_container">
              <p>Choose Payout Method</p>
              <Select
                placeholder="Select"
                className="withdrawalSelectors"
                options={methodOptions}
                classNamePrefix="react-select"
                styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                name="method"
                value={methodOptions?.find((option) => option.value === payout.crypto_type) || null}
                onChange={handleSelectMethod}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isSearchable={false}
              />
            </div>
            <div className="col1_lower_select_container">
              <p>Reason</p>
              <textarea
                type="text"
                name="reason"
                value={payout.reason}
                onChange={handleInputChange}
                placeholder="Reason"
                className="reason_section"
                cols={1}
                rows={4}
                maxLength={500}
              />
            </div>
          </div>
          <div className="col1_button">
            <button
              onClick={handleSubmit}
              disabled={isSpinner || !totalAmounts}
            >
              {isSpinner ? <Spinner /> : <>Submit</>}
            </button>
          </div>
        </div>
      </div>
      <div className="addressBox">
        <InvoiceDetails
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          variant={2}
        />
      </div>{" "}
    </div>
  );
}

export default AffiliatePayout;
